import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'
import useAudioManager from '../hooks/useAudioManager'
import { getNavigationItems } from '../config/navigationConfig'

const BottomNavigation = () => {
  const { t } = useTranslation()

  const { playSound } = useAudioManager({
    pick: 'pick'
  })

  const navItems = getNavigationItems(t)

  // Функция вибрации при клике
  const handleNavClick = () => {
    try {
      playSound('pick')

      if (window.Telegram?.WebApp?.HapticFeedback) {
        window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy')
      }
    } catch (error) {
      // Игнорируем ошибки вибрации
    }
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-surface border-t border-white border-opacity-10 z-40">
      <div className="max-w-[600px] mx-auto flex items-center justify-around py-2">
        {navItems.map((item) => {
          const Icon = item.icon
          return (
            <NavLink
              key={item.path}
              to={item.path}
              end={item.exact}
              onClick={handleNavClick}
              className={({ isActive }) =>
                classNames(
                  'flex flex-col items-center justify-center px-3 py-2 rounded-lg transition-all duration-200',
                  {
                    'text-accent-primary': isActive,
                    'text-text-secondary hover:text-text-primary': !isActive
                  }
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon 
                    size={20} 
                    className={classNames('mb-1', {
                      'drop-shadow-[0_0_8px_rgba(0,255,127,0.6)]': isActive
                    })} 
                  />
                  <span className="text-xs font-medium">{item.label}</span>
                </>
              )}
            </NavLink>
          )
        })}
      </div>
    </nav>
  )
}

export default BottomNavigation
